import { createRequest, applicantCreateUpdateRequest, createUpdateEncryptRequest, paymentGatewayRESTCall, createRequestFileUpload, applicantCreateRequest, createRequestPayment, createRequestFreezeUnFreeze } from './helper';
import Config from '../../config/appConstants';
import WarningAlertImg from '../../assets/images/Alerts/warning.svg';
import translateLabel from "../../components/shared/translation";
import Swal from 'sweetalert2';

//GET
export async function getAPI(uri, params) {
    return await createRequest('GET', uri, 1, '', params)
        .then((response) => {
            return response.data;
        })
        .catch(function (error) {
            if (error && error.hasOwnProperty("code") && error.code === Config.API_ERROR_RESP_CODE.InvalidSessionID) {
                invalidSessionID();
            } else {
                return false;
            }
        });
}

//PUT_POST
export async function sendAPI(type, uri, payload, params, isActualResponse = false) {
    return await applicantCreateUpdateRequest(type, uri, 1, payload, params)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            if (error && error.hasOwnProperty("code") && error.code === Config.API_ERROR_RESP_CODE.InvalidSessionID) {
                invalidSessionID();
            }
            else if(isActualResponse){
                return error;
            }
             else {
                return false;
            }
        });
}

//PUT_POST
export async function sendEncryptPayloadAPI(type, uri, payload, params) {
    return await createUpdateEncryptRequest(type, uri, 1, payload, params)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            if (error && error.hasOwnProperty("code") && error.code === Config.API_ERROR_RESP_CODE.InvalidSessionID) {
                invalidSessionID();
            } else {
                return false;
            }
        });
}

//PKI Login - Auth API Call
export async function createAuthAPIRequest(type, uri, payload, params, returnActuallResponse = false) {
    return await createRequest(type, uri, 0, payload, params)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            if (error && error.hasOwnProperty("code") && error.code === Config.API_ERROR_RESP_CODE.InvalidSessionID) {
                invalidSessionID();
            } 
            else if(returnActuallResponse) {
                return error;
            }
            else {
                return false;
            }
        });
}

//PUT_POST using createRequest
export async function createAPIRequest(type, uri, payload, params, customAttributes = {}) {
    return await createRequest(type, uri, 1, payload, params, customAttributes)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            if (error && error.hasOwnProperty("code") && error.code === Config.API_ERROR_RESP_CODE.InvalidSessionID) {
                invalidSessionID();
            } else if (customAttributes && customAttributes.hasOwnProperty("ReturnErrorResponseBody") && customAttributes.ReturnErrorResponseBody) {
                return error;
            } else {
                return false;
            }
        });
}

//Create Request File Upload
export async function createAPIRequestFileUpload(type, uri, payload, encMode, customAttributes = {}) {
    return await createRequestFileUpload(type, uri, 1, payload, encMode, customAttributes)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            if (error && error.hasOwnProperty("code") && error.code === Config.API_ERROR_RESP_CODE.InvalidSessionID) {
                invalidSessionID();
            } else {
                return false;
            }
        });
}

//Create and Update Application Endpoint
export async function applicationCreateUpdateAPIRequest(type, uri, payload, params) {
    return await applicantCreateRequest(type, uri, 1, payload, params)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            if (error && error.hasOwnProperty("code") && error.code === Config.API_ERROR_RESP_CODE.InvalidSessionID) {
                invalidSessionID();
            } else {
                return false;
            }
        });
}

export async function paymentGatewayGetAPI(uri, params, sessionID) {
    return await paymentGatewayRESTCall('GET', uri, 1, params, sessionID)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            if (error && error.hasOwnProperty("code") && error.code === Config.API_ERROR_RESP_CODE.InvalidSessionID) {
                invalidSessionID();
            } else {
                return false;
            }
        });
}

export async function createPaymentAPIRequest(type, uri, payload, params) {
    return await createRequestPayment(type, uri, 1, payload, params)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            if (error && error.hasOwnProperty("code") && error.code === Config.API_ERROR_RESP_CODE.InvalidSessionID) {
                invalidSessionID();
            } else {
                return false;
            }
        });
}

export async function KrookiValidation(params) {
    return await createRequest('GET', Config.KROOKI_VALIDATION, 1, '', params)
        .then((response) => {
            return response.data;
        })
        .catch(function (error) {
            if (error && error.hasOwnProperty("code") && error.code === Config.API_ERROR_RESP_CODE.InvalidSessionID) {
                invalidSessionID();
            } else {
                return false;
            }
        });
}

export async function GetLandInvolvedParty(params) {
    return await createRequest('GET', Config.GETLAND_INVOLVEDPARTYID + "/residential", 1, '', params)
        .then((response) => {
            return response.data;
        })
        .catch(function (error) {
            if (error && error.hasOwnProperty("code") && error.code === Config.API_ERROR_RESP_CODE.InvalidSessionID) {
                invalidSessionID();
            } else {
                return false;
            }
        });
}

export async function getInvolvedParty(params) {
    return await createRequest('GET', Config.GET_INVOVLED_PARTY, 1, '', params)
        .then((response) => {
            return response.data;
        })
        .catch(function (error) {
            if (error && error.hasOwnProperty("code") && error.code === Config.API_ERROR_RESP_CODE.InvalidSessionID) {
                invalidSessionID();
            } else {
                return false;
            }
        });
}

export async function createAPIRequestFreezeUnFreeze(type, uri, payload, params, InvolvedPartyID) {
    return await createRequestFreezeUnFreeze(type, uri, 1, payload, params, InvolvedPartyID)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            if (error && error.hasOwnProperty("code") && error.code === Config.API_ERROR_RESP_CODE.InvalidSessionID) {
                invalidSessionID();
            } else {
                return false;
            }
        });
}

async function invalidSessionID() {
    localStorage.setItem("SessionExpired", "true");
    Swal.fire({
        title: translateLabel("SESSION_EXPIRED"),
        text: translateLabel("PLS_LOGIN_AGAIN"),
        imageUrl: WarningAlertImg,
        imageWidth: 175,
        imageHeight: 80,
        imageAlt: WarningAlertImg,
        confirmButtonColor: '#056ca2',
        confirmButtonText: translateLabel("OK")
    }).then((result) => {
        localStorage.clear();
        window.location = '/';
    })
}